import { FC, Fragment } from 'react';
import { SkeletonBlock } from 'pages/ReportsPage/components/AnalyticsDashboards/Skeleton/Skeleton.styled';
import {
  StatCardRowContainer,
  StatCardItem,
} from 'pages/ReportsPage/components/AnalyticsDashboards/KpiStatCardRow/KpiStatCardRow.styled';
import { StatCardContainer } from 'pages/ReportsPage/components/AnalyticsDashboards/KpiStatCard/KpiStatCard.styled';
import { WidgetGrid } from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/OverviewDashboard.styled';
import {
  WidgetCard,
  WidgetCardHeader,
} from 'pages/ReportsPage/components/AnalyticsDashboards/WidgetCardWrapper/WidgetCardWrapper.styled';

interface DashboardSkeletonProps {
  kpiCount?: number;
  widgetCount?: number;
}

export const DashboardSkeleton: FC<DashboardSkeletonProps> = ({
  kpiCount = 4,
  widgetCount = 4,
}) => (
  <Fragment>
    {kpiCount > 0 && (
      <StatCardRowContainer>
        {Array.from({ length: kpiCount }).map((_, index) => (
          <StatCardItem key={index}>
            <StatCardContainer>
              <SkeletonBlock $height="14px" $width="55%" />
              <SkeletonBlock $height="30px" $width="80%" />
              <SkeletonBlock $height="12px" $width="45%" />
            </StatCardContainer>
          </StatCardItem>
        ))}
      </StatCardRowContainer>
    )}
    <WidgetGrid>
      {Array.from({ length: widgetCount }).map((_, index) => (
        <WidgetCard key={index}>
          <WidgetCardHeader>
            <SkeletonBlock $height="16px" $width="40%" />
            <SkeletonBlock $height="12px" $width="60%" />
          </WidgetCardHeader>
          <SkeletonBlock $height="200px" $width="100%" $radius="8px" />
        </WidgetCard>
      ))}
    </WidgetGrid>
  </Fragment>
);
